import styled from "@emotion/styled";

export const StyledTemplateTable = styled.div`
  table {
    border-spacing: 0;
    border: none;
    color: #212242;
    width: 100%;
    margin-top: 1rem;

    thead {
      padding-left: 1rem;
    }

    tbody {
      tr td {
        font-size: 14px;

        :first-of-type {
          padding-left: 1rem
        }
      }
    }

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    tr th {
      background: #f6f8fc;
      padding: 0.6rem 0;
      text-align: left;
      line-height: 1.5rem;
      font-size: 0.875rem;
      font-weight: 600;
      vertical-align: inherit;
      border-bottom: 1px solid rgb(241, 243, 244);
      text-align: left;
      // width: 48px;
      // color: rgb(99, 115, 129);
      background-color: rgb(244, 246, 248);

      :first-of-type {
        padding-left: 1rem
      }
    }

    tr td {
      padding: 0.7rem 0;
      word-wrap: break-word;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    th, td {
      margin: 0;
      border-bottom: 1px solid #eee;
      border-right: none;
      padding: 5px;

      :last-child {
        border-right: 0;
      }
    }
  }
  .pagination {
    padding: 0.5rem;
  }
`;